import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild
} from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Animations } from "src/app/_helpers/animations";
import { timePickerCustomTheme } from "src/app/_helpers/timePickerTheme";
import { SpaceAssignmentSharedModel } from "src/app/_models/space-assignment.model";
import { UserService } from "src/app/_services";
import { ThisPlatform } from "src/app/_services/platform.service";
import { PushNotificationService } from "src/app/_services/push-notification.service";
import { SpaceService } from "src/app/_services/space.service";

@Component({
  selector: "app-user-assignment-view-quick-share",
  templateUrl: "./user-assignment-view-quick-share.component.html",
  styleUrls: ["./user-assignment-view-quick-share.component.scss"],
  animations: [Animations.animeHeight],
})
export class UserAssignmentViewQuickShareComponent implements OnInit {
  @Input()
  assignmentDetails;

  @Input()
  pushIdConfirmation;

  @Input()
  notificationConfirmation;

  showHours: boolean = true;

  spaceToShare: SpaceAssignmentSharedModel = new SpaceAssignmentSharedModel();

  constructor(
    public modalCtrl: ModalController,
    public userService: UserService,
    public p: ThisPlatform,
    private el: ElementRef,
    public renderer: Renderer2,
    private spaceService: SpaceService,
    private translateService: TranslateService,
    private pushNotificationService: PushNotificationService
  ) {}

  minTime = "6:00 am"; // Do sprawdzenia w Time Picker
  maxTime = "7:00 pm"; // Do sprawdzenia w Time Picker

  startDate: Date = new Date();
  endDate: Date;
  validationError: boolean = false;
  timePickerCustomTheme = timePickerCustomTheme;
  errorMessage: string = "";
  data: {
    dateFrom: Date;
  };

  @ViewChild("buttonsContainer") buttonsContainer;

  ngOnInit() {
    this.endDate = new Date(new Date().getTime() + 30 * 60000);
  }

  ngAfterViewInit() {
    if (!this.notificationConfirmation) {
      this.renderer.addClass(
        this.buttonsContainer.el.children[0].children[0],
        "user-assignment-view-share__hour-button--active"
      );
    }
  }

  onShareAssignmentDayEnd() {
    this.endDate = new Date(new Date().setHours(19, 0, 0, 0));
    this.modalCtrl.dismiss([this.startDate, this.endDate]);
  }

  currentTimeWithAddedHours(i) {
    return new Date().getHours() + i + ":" + new Date().getMinutes();
  }

  onShareSpaceHours(event, value) {
    for (let item of this.buttonsContainer.el.children) {
      this.renderer.removeClass(
        item.children[0],
        "user-assignment-view-share__hour-button--active"
      );
    }
    this.renderer.addClass(
      event.currentTarget,
      "user-assignment-view-share__hour-button--active"
    );

    if (value == "byDayEnd") {
      this.setShareEndTime(value, true);
    } else {
      this.setShareEndTime(value, false);
    }
  }

  setShareEndTime(value, byDayEnd?: boolean) {
    let today = new Date();

    if(byDayEnd){
      this.endDate = new Date(today.setHours(19, 0));
    } else {
      this.endDate = value >= 1 
        ? new Date(new Date().setHours(new Date().getHours() + value))
        : new Date(new Date().getTime() + value * 60 * 60000);
    }
    // Skoro po 19'nastej ten formularz się nie pojawia to wracam do wczesniejszego ograniczenia do 19
    if(this.endDate.getHours() >= 19){
      this.endDate = new Date(today.setHours(19, 0));
    }
  }

  onShareSpaceNotification() {
    this.spaceToShare.idSpaceAssignment = Number(this.assignmentDetails.id);
    this.spaceToShare.dateFrom = this.startDate;
    this.spaceToShare.dateTo = this.endDate;

    this.spaceService.addAssignmentShared(this.spaceToShare).subscribe(
      () => {
        this.pushNotificationService
          .pushConfirmation(this.pushIdConfirmation, "confirmed")
          .subscribe((el) => {
          });
        this.modalCtrl.dismiss(null, "share");
      },
      (err) => {
        switch (err.error.code) {
          case 1: {
            this.errorMessage = this.translateService.instant(
              "SPACE.ERROR.ERROR_1"
            );
            break;
          }
          case 2: {
            this.errorMessage = this.translateService.instant(
              "SPACE.ERROR.ERROR_2"
            );
            break;
          }
        }
      }
    );
  }

  onShareSpaceBarierr() {
    this.modalCtrl.dismiss([this.startDate, this.endDate], "share");
  }

  onSetEndTime(endDate) {
    for (let item of this.buttonsContainer.el.children) {
      this.renderer.removeClass(
        item.children[0],
        "user-assignment-view-share__hour-button--active"
      );
    }

    this.endDate = endDate;
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }

  onSave() {
    this.modalCtrl.dismiss("", "share");
  }
}
